var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagUs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "flag-us_svg__a",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-us_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7FCFF",
  fillRule: "evenodd",
  d: "M0 0h32v24H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E31D1C",
  fillRule: "evenodd",
  d: "M0 14.667v2h32v-2zM0 18.333v2h32v-2zM0 7.333v2h32v-2zM0 22v2h32v-2zM0 11v2h32v-2zM0 0v2h32V0zM0 3.667v2h32v-2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E42A5",
  d: "M0 0h20v13H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7FCFF",
  d: "M2.053 9.968h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm-14-2h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm-14-2h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm-14-2h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm-14-2h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.702-.51-.727.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739zm4 0h.717l-.564.573.219.907-.703-.51-.726.51.245-.907-.644-.573h.841l.284-.739z"
}))));
export default SvgFlagUs;